// Mock data for Axiom Global Freight LLC Landing Page

export const companyInfo = {
  name: "Axiom Global Freight LLC",
  tagline: "Delivering Excellence Worldwide",
  phone: "+1 (646) 261-2124",
  email: "info@axiomfreight.com",
  address: "228 Park Ave S #432555, New York, NY 10003, USA"
};

export const heroData = {
  headline: "We Deliver",
  headlineHighlight: "the World",
  subheadline: "Your trusted partner for seamless global freight solutions. From air cargo to ocean freight, we connect your business to every corner of the globe with speed, reliability, and precision.",
  backgroundImage: "https://images.unsplash.com/photo-1720428112577-528107b9c140",
  ctaPrimary: "Request a Quote",
  ctaSecondary: "Track Shipment"
};

export const services = [
  {
    id: "air-freight",
    title: "Air Freight Solutions",
    description: "Time-critical deliveries with our global airline partnerships. 24/7 service for urgent cargo needs.",
    icon: "Plane",
    features: ["Next Flight Out (NFO)", "Temperature Controlled", "AOG Services"]
  },
  {
    id: "ocean-freight",
    title: "Ocean Freight",
    description: "Cost-effective sea transport with full container load (FCL) and less-than-container load (LCL) options.",
    icon: "Ship",
    features: ["FCL & LCL Services", "Port-to-Port", "Door-to-Door"]
  },
  {
    id: "customs",
    title: "Customs Brokerage",
    description: "Expert customs clearance services ensuring smooth and compliant border crossings worldwide.",
    icon: "FileCheck",
    features: ["Documentation", "Compliance", "Duty Management"]
  },
  {
    id: "trucking",
    title: "Trucking & Ground",
    description: "Reliable ground transportation with nationwide coverage and last-mile delivery solutions.",
    icon: "Truck",
    features: ["FTL & LTL", "Express Delivery", "Last Mile"]
  }
];

export const solutionTabs = [
  { id: "end-to-end", label: "End-to-End Freight" },
  { id: "air-freight", label: "Air Freight" },
  { id: "ocean-freight", label: "Ocean Freight" },
  { id: "project", label: "Project Logistics" },
  { id: "customs", label: "Customs Brokerage" },
  { id: "trucking", label: "Trucking" }
];

export const keyHighlights = [
  "Time Critical Deliveries",
  "Temperature Controlled Facilities",
  "Aircraft on Ground – AOG",
  "Next Flight Out – NFO",
  "International / Domestic Operations",
  "Customs Brokerage",
  "24/7/365 Service & Tracking",
  "Diplomatic Cargo Charters",
  "Oversized Cargo Movements",
  "Express Pick up & Delivery"
];

export const stats = [
  { value: "50+", label: "Countries Served" },
  { value: "10K+", label: "Shipments Monthly" },
  { value: "99.7%", label: "On-Time Delivery" },
  { value: "24/7", label: "Support Available" }
];

export const whyChooseUs = [
  {
    title: "Global Network",
    description: "Strategic partnerships with major carriers and agents across 50+ countries.",
    icon: "Globe"
  },
  {
    title: "Real-Time Tracking",
    description: "Full visibility of your shipments with advanced tracking technology.",
    icon: "MapPin"
  },
  {
    title: "Expert Team",
    description: "Experienced logistics professionals dedicated to your success.",
    icon: "Users"
  },
  {
    title: "Flexible Solutions",
    description: "Customized freight solutions tailored to your unique business needs.",
    icon: "Settings"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Axiom Global Freight has transformed our supply chain operations. Their reliability and responsiveness are unmatched in the industry.",
    author: "Michael Chen",
    role: "Supply Chain Director",
    company: "TechPro Industries"
  },
  {
    id: 2,
    quote: "When we needed urgent cargo delivery for our manufacturing line, Axiom came through within hours. They saved our production schedule.",
    author: "Sarah Rodriguez",
    role: "Operations Manager",
    company: "AutoParts Global"
  },
  {
    id: 3,
    quote: "The team's expertise in customs brokerage has eliminated delays and reduced our compliance headaches significantly.",
    author: "David Thompson",
    role: "Import/Export Manager",
    company: "MedTech Solutions"
  }
];

export const footerLinks = {
  solutions: [
    { label: "Air Freight", href: "#air-freight" },
    { label: "Ocean Freight", href: "#ocean-freight" },
    { label: "Customs Brokerage", href: "#customs" },
    { label: "Trucking", href: "#trucking" }
  ],
  company: [
    { label: "About Us", href: "#about" },
    { label: "Contact", href: "#contact" }
  ],
  resources: [
    { label: "Request Quote", href: "#quote" },
    { label: "Industry News", href: "#news" },
    { label: "FAQ", href: "#faq" }
  ]
};

export const images = {
  hero: "https://images.unsplash.com/photo-1720428112577-528107b9c140",
  plane: "https://images.unsplash.com/photo-1722256104612-044cfe542010",
  containers: "https://images.unsplash.com/photo-1672870152741-e526cfe5419b",
  warehouse: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d",
  forklift: "https://images.unsplash.com/photo-1645736315000-6f788915923b"
};
